export default {
  items_th: [
    {
      name: 'หน้าหลัก',
      url: '/main',
      icon: 'cui-home icons font-1xl'
    },
    {
      name: 'ภาวะการมีงานทำ',
      url: '/general',
      icon: 'cui-pencil font-1xl'
    },
    {
      name: 'แบบประเมินตนเองของบัณฑิตต่อทักษะแห่งอนาคต',
      url: '/part10',
      icon: 'cui-pencil font-1xl'
    },
    // {
    //   name: 'แจ้งความประสงค์เข้ารับปริญญาบัตร',
    //   url: '/Regis',
    //   icon: 'cui-pencil font-1xl'
    // },
    {
      name: 'ออกจากระบบ',
      url: '/thank',
      icon: 'cui-account-logout font-1xl'
    }
  ],
  items_th70: [
    {
      name: 'หน้าหลัก',
      url: '/main70',
      icon: 'cui-home icons font-1xl'
    },
    // {
    //   name: 'แจ้งความประสงค์เข้ารับปริญญาบัตร',
    //   url: '/Regis',
    //   icon: 'cui-pencil font-1xl'
    // },
    {
      name: 'ออกจากระบบ',
      url: '/thank',
      icon: 'cui-account-logout font-1xl'
    }
  ],

  items_eng: [
    {
      name: 'Home',
      url: '/main',
      icon: 'cui-home icons font-1xl '
    },
    {
      name: 'Employment Survey',
      url: '/general',
      icon: 'cui-pencil font-1xl'
    },
    {
      name: 'Graduates’ Self-Assessment of Future Skills',
      url: '/part10',
      icon: 'cui-pencil font-1xl'
    },
    // {
    //   name: 'Confirmation to attend the commencement ceremony',
    //   url: '/Regis',
    //   icon: 'cui-pencil font-1xl'
    // },
    {
      name: 'Logout',
      url: '/thank',
      icon: 'cui-account-logout font-1xl'
    }


  ],
  items_eng70: [
    {
      name: 'Home',
      url: '/main70',
      icon: 'cui-home icons font-1xl'
    },
    // {
    //   name: 'Confirmation to attend the commencement ceremony',
    //   url: '/Regis',
    //   icon: 'cui-pencil font-1xl'
    // },
    {
      name: 'Logout',
      url: '/thank',
      icon: 'cui-account-logout font-1xl'
    }
  ],
  items_logout: [
    {
      name: 'Login',
      url: '/login',
      icon: 'cui-note font-1xl'
    }
  ],
  items_report: [
    {
      name: 'ค้นหา',
      url: '/search',
      icon: 'cui-home icons font-1xl '
    },
    {
      name: 'จำแนกวันที่บันทึก',
      url: '/reportdate',
      icon: 'cui-people icons font-1xl '
    },
    {
      name: 'จำแนกสำนักวิชา',
      url: '/reportfaculty',
      icon: 'cui-screen-desktop icons font-1xl '
    },
    {
      name: 'สถิติแยกตามประเภท(เฉพาะต่างชาติ)',
      url: '/reporttypeforeigners',
      icon: 'cui-screen-desktop icons font-1xl '
    },
    {
      name: 'เข้าสู่ระบบ',
      url: '/index',
      icon: 'cui-screen-desktop icons font-1xl '
    },
    // {
    //   name: 'จำแนกสาขาวิชา ',
    //   url: '/Reportdept',
    //   icon: 'cui-people icons font-1xl '
    // },
    // {
    //   name: 'จำแนกสาขาวิชา 2562',
    //   url: '/Reportdept_62',
    //   icon: 'cui-people icons font-1xl '
    // },

    // {
    //   name: 'CreateGraduate',
    //   url: '/Graduate',
    //   icon: 'cui-people icons font-1xl '
    // },
    //  {
    //   name: 'สถิติแยกตามประเภท 2563',
    //   url: '/Reporttype',
    //   icon: 'cui-screen-desktop icons font-1xl '
    // },
    /*  {
        // ยังไม่ดำเนินการขึ้นทะเบียนบัณฑิต
        name: 'ไม่ได้บันทึกข้อมูล',
        url: '/Reportnotregis',
        icon: 'cui-star icons font-1xl '
      },
      {
        name: 'บันทึกไม่สมบูรณ์',
        url: '/Reportincompleted',
        icon: 'cui-star icons font-1xl '
      },*/
    // {
    //   name: 'สถิติแยกตามประเภท(เฉพาะจีน)',
    //   url: '/Reporttypechinese',
    //   icon: 'cui-screen-desktop icons font-1xl '
    // },

    // {
    //   name: 'สถิติแยกตามประเภท(เฉพาะต่างชาติ)',
    //   url: '/Reporttypeforeigners',
    //   icon: 'cui-screen-desktop icons font-1xl '
    // },
    /* {
       // ยังไม่ดำเนินการขึ้นทะเบียนบัณฑิต(เฉพาะต่างชาติ)
       name: 'ไม่ได้บันทึกข้อมูล(เฉพาะต่างชาติ)',
       url: '/Reportnotregisforeigners',
       icon: 'cui-star icons font-1xl '
     },
     {
       name: 'บันทึกไม่สมบูรณ์(เฉพาะต่างชาติ)',
       url: '/Reportincompleted_eng',
       icon: 'cui-star icons font-1xl '
     },*/
    /* {
       name: 'เข้าสู่ระบบ',
       url: 'index',
       icon: 'cui-check icons font-1xl '
     }*/
  ]
}
